import { BaseWidget, WidgetCategory, WidgetDefinition } from './base.types';
import { ChartPosition, LabelFormatterOption } from './types';

export enum LineSubType {
  Spline = 'SPLINE',
  Line = 'LINE',
}

export enum LineLegendPosition {
  Top = 'TOP',
  Bottom = 'BOTTOM',
  None = 'NONE',
}

export type LineLegend = {
  position: LineLegendPosition;
  margin?: { top?: number; bottom?: number; left?: number; right?: number };
};

export type LineCustomDefinition = {
  fieldsPalette: Record<string, string>;
  legend: LineLegend;
  customLabels?: { x?: string; y?: string; yAxisWidth?: number };
  labelFormatter?: LabelFormatterOption;
  chartPosition?: ChartPosition;
  showDataLabels?: boolean;
};

export type LineWidget = BaseWidget & {
  category: WidgetCategory.Line;
  definition: WidgetDefinition & { custom: LineCustomDefinition };
  type: LineSubType;
};

export type LineTypeWidget = LineWidget & {
  type: LineSubType.Line;
};

export type SplineTypeWidget = LineWidget & {
  type: LineSubType.Spline;
};

export type LineCategoryWidgetTypes = LineTypeWidget | SplineTypeWidget;
